import { Injectable } from '@angular/core';
import { MemberClub } from '../../models/clubs/member-club.model';
import { Member } from '../../models/clubs/member.model';
import { MemberApiService } from '../../services/clubs/member.api.service';
import { ClubsStore } from '../clubs.store';
import { ClubActivityService } from './club-activity.service';

@Injectable({
    providedIn: 'root',
})
export class MemberService {
    constructor(
        private readonly clubsStore: ClubsStore,
        private readonly memberApiService: MemberApiService,
        private readonly clubActivityService: ClubActivityService,
    ) {}

    public getRoomLastVisitDate(): Date {
        const index = this.clubsStore.member.clubs.findIndex((club) => club.clubId === this.clubsStore.displayedRoomId);
        const lastVisitDate = index > -1 ? this.clubsStore.member.clubs[index].lastVisitDate : this.clubsStore.displayedRoom?.creationDate;

        return lastVisitDate;
    }

    public updateMemberLastVisitDay(shouldUpdate: boolean) {
        if (shouldUpdate) {
            this.memberApiService.updateMemberAccessDate(this.clubsStore.member.id, this.clubsStore.displayedRoomId).subscribe(() => {
                this.clubActivityService.loadAllClubsActivity();
            });
            const currentRoomDetails = this.clubsStore.member.clubs.find((club) => club.id === this.clubsStore.displayedRoomId);
            if (currentRoomDetails != null) {
                const index = this.clubsStore.member.clubs.findIndex((club) => club.id === this.clubsStore.displayedRoomId);
                this.clubsStore.member.clubs[index].lastVisitDate = new Date();
            } else {
                const newClub: MemberClub = {
                    id: this.clubsStore.displayedRoomId,
                    clubId: this.clubsStore.displayedRoomId,
                    role: this.clubsStore.roleInDisplayedRoom,
                    lastVisitDate: new Date(),
                };

                this.clubsStore.member.clubs.push(newClub);
            }
        }
    }

    public updateAllClubsLastVisitDate() {
        this.memberApiService.updateAllClubsAccessDate().subscribe(() => {
            this.clubActivityService.loadAllClubsActivity();
            this.clubsStore.member.clubs.forEach((club) => {
                club.lastVisitDate = new Date();
            });
        });
    }

    public getFullName(member: Member): string {
        return `${member.firstName} ${member.lastName}`;
    }
}
